import { Row } from "antd";
import { foracc } from "../src/assets/images";

const Closed = () => {
  return (
    // <div className="closed">
    // <h1>Sorry, we are closed</h1>
    // </div>
    <>
      <Row justify={"center"}>
        <img
          src={foracc}
          style={{
            maxWidth: "100%",
          }}
        />
      </Row>
      <Row justify={"center"}>
        <h3>El periodo de inscripción ha concluido.</h3>
      </Row>
    </>
  );
};

export default Closed;
